export enum Locale {
    English="en",
    EnglishAlt="us",
    Swedish="sv",
    SwedishAlt="se"
}
export const DefaultLocales = [
    { id: Locale.English, label: "English", alt: Locale.EnglishAlt },
    { id: Locale.Swedish, label: "svenska", alt: Locale.SwedishAlt }
]